/* unplugin-vue-components disabled */
export default {
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  computed: {
    name() {
      return this.file.name.substring(0, this.file.name.lastIndexOf('.')) || this.file.name
    },
    size() {
      const file_size = this.file.size || 0
      return $utils.format.bytes(file_size)
    },
    src(){
      return this.file.url
    },
  }
}
